import HelpIcon from "@mui/icons-material/HelpOutlineRounded";
import { Stack, Tooltip, Typography } from "@mui/material";
import type { EmailTrackingStatus } from "../../api/types/emailsTypes";
import { emailTrackingStatusCaptionsMap } from "../../utilities/enumCaptions";
import DetailedTooltipTitle from "../common/DetailedTooltipTitle";

interface Props {
  status: EmailTrackingStatus;
  deliveryFailureMessage?: string;
  deliveryFailureMessageExplanation?: string;
}

const EmailStatus = ({ status, deliveryFailureMessage, deliveryFailureMessageExplanation }: Props) => (
  <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
    <Typography color={status === "PermanentFailure" ? "error" : "textPrimary"}>
      {emailTrackingStatusCaptionsMap[status]}
    </Typography>
    {deliveryFailureMessage && (
      <Tooltip
        title={<DetailedTooltipTitle title={deliveryFailureMessage} details={deliveryFailureMessageExplanation} />}
      >
        <HelpIcon sx={(t) => ({ color: t.palette.secondary.light })} />
      </Tooltip>
    )}
  </Stack>
);

export default EmailStatus;
